module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('canvas', {
    staticStyle: {
      "width": "100%",
      "display": "block"
    }
  }), _c('div', {
    staticClass: "annotationLayer"
  }), _c('resize-sensor', {
    on: {
      "resize": _vm.resize
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1421e7e5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1421e7e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-pdf/src/pdf.vue
// module id = 2338
// module chunks = 2